__webpack_require__.p = "https://selmecikockajusko-portfolio.vercel.app/";